// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import { loadSavedTheme } from '@/utils/themes'
import { loadSavedFont } from '@/utils/fonts'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";


loadSavedTheme()
loadSavedFont()

const app = createApp(App)

app.use(router)

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = `${to.meta.title}`
    }
    next()
})
app.use(Toast, {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
});
app.mount('#app')